import { gql } from '@biletiniz/apollo';

export const COMBINE_FLIGHT_OFFERS_QUERY = gql`
  query combineFlightOffers($session: String!, $flightOffersIDs: [String]!) {
    combineFlightOffers(session: $session, flightOffersIDs: $flightOffersIDs)
  }
`;
